import { ReactNode, useEffect, useState } from "react";

import useJobsAPI from "../../hooks/useJobsAPI";

import useJobsPageStore from "./hooks/useJobsPageStore";
import { Column, Row } from "../../components/Layout";

import CompanyList from "./components/CompanyList";
import CompanyJobsListings from "./components/CompanyJobListings";


export default function Jobs() {
    const { summary, loading, fetchSummary } = useJobsAPI()
    const { selectedKey, selectedRegion } = useJobsPageStore()

    useEffect(() => {

        if (selectedKey != null) {
            fetchSummary(selectedKey, selectedRegion)
        }

    }, [selectedKey, selectedRegion])

    return (
        <Row fullHeight>
            <Column className="w-3/12">
                <CompanyList />
            </Column>

            <Column className="w-9/12">
                <CompanyJobsListings loading={loading} summary={summary} />
            </Column>
        </Row>
    )

}